import * as React from 'react';
import styles from './TextAreaField.styl';
import classnames from 'classnames';
class TextAreaField extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "onChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
                const { name } = this.props;
                const value = event.nativeEvent.target.value;
                this.props.onChange(value, name, event);
            }
        });
        Object.defineProperty(this, "onFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ focused: true });
            }
        });
        Object.defineProperty(this, "onBlur", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ focused: false });
            }
        });
        this.state = {
            focused: false
        };
    }
    render() {
        const { className, fieldClassName, showPlaceholder, label, value, placeholder, hideLabelInner, disabled, maxLength, error } = this.props;
        const showLabel = (this.state.focused || value && showPlaceholder) ? `${styles.placeholderAnimate} ${styles.placeholderAnimateShow}` : `${styles.placeholderAnimate}`;
        return (React.createElement("div", { className: `${styles.textField} ${className}` },
            !hideLabelInner ? React.createElement("span", { className: showLabel }, label) : '',
            React.createElement("textarea", { className: classnames(styles.input, fieldClassName, { [styles.error]: error }), value: value, placeholder: placeholder, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, disabled: disabled, maxLength: maxLength })));
    }
}
export default TextAreaField;
